export enum TriSelectedState {
  Selected = 'Selected',
  Indeterminate = 'Indeterminate',
  NotSelected = 'NotSelected'
}
